// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__d6-Rq","content":"styles_content__3_277","checkbox":"styles_checkbox__3xRrm","checkboxLabel":"styles_checkboxLabel__1c2NH"};